import { api } from '~/services/api'

export const apiExport = (params) => {
  const uri = `/v1/file-watchers/export`
  return api.get(uri, params)
}

export const apiGetTemplate = (params) => {
  const uri = `/v1/file-watchers/export`
  return api.get(uri, params)
}

export const apiImport = (params) => {
  const uri = `/v1/file-watchers/export`
  return api.get(uri, params)
}
